module.exports = __webpack_public_path__ + "img/icon_benefit_05_01.aaa9793f.svg";